import * as types from "./mutation-types";

const mutations = {
  [types.ADD_TEAM](state, team) {
    state.stagedTeams.push(team);
  },

  [types.REMOVE_TEAM](state, teamIndex) {
    state.stagedTeams.splice(teamIndex, 1);
  },

  [types.EMPTY_STAGED_TEAMS](state) {
    state.stagedTeams.splice(0, state.stagedTeams.length);
  },

  [types.ADD_MEMBER](state, member) {
    state.stagedMembers.push(member);
  },

  [types.REMOVE_MEMBER](state, memberIndex) {
    state.stagedMembers.splice(memberIndex, 1);
  },

  [types.EMPTY_STAGED_MEMBERS](state) {
    state.stagedMembers.splice(0, state.stagedMembers.length);
  },

  [types.ADD_ORGNIZATION](state, organization) {
    state.stagedOrganizations.push(organization);
  },

  [types.REMOVE_ORGNIZATION](state, organizationIndex) {
    state.stagedOrganizations.splice(organizationIndex, 1);
  },

  [types.EMPTY_STAGED_ORGNIZATIONS](state) {
    state.stagedOrganizations.splice(0, state.stagedOrganizations.length);
  },

  [types.SET_ACTIVE_STEP](state, step) {
    state.activeStep = step;
  },

  [types.UPDATE_FORM_DATA](state, data) {
    state.formData[data.key].value = data.value;
  },

  [types.UPDATE_OPTION](state, data) {
    state.options[data.key] = data.value;
  },

  [types.SET_FORM_DATA](state, data) {
    state.formData = data;
  },

  [types.SET_STAGED_TEAMS](state, teams) {
    state.stagedTeams = teams;
  },

  [types.SET_MEMBERS](state, members) {
    state.stagedMembers = members;
  },

  [types.SET_ORGNIZATIONS](state, organizations) {
    state.stagedOrganizations = organizations;
  },

  [types.SET_OPTIONS](state, options) {
    state.options = options;
  },

  [types.SET_PACKAGE_MODE](state, value) {
    state.packageMode = value;
  },

  [types.SET_TEAM_MODE](state, value) {
    state.teamMode = value;
  },

  [types.SET_MEMBER_MODE](state, value) {
    state.memberMode = value;
  },

  [types.SET_SELECTED_PACKAGE](state, cPackage) {
    state.selectedPackage = cPackage;
  },
  [types.SET_POINTS_GOAL_PER_DAY](state, value) {
    state.pointsGoalPerDay = value;
  }
};

export default mutations;
